/**
 * Resolve localized world metadata (name, description, tags, genre)
 * from the world's config.translations based on the current locale.
 */

export interface WorldTranslationData {
  name?: string;
  description?: string;
  tags?: string[];
  genre?: string;
  promo?: string;
}

export function getLocalizedWorldName(
  world: { name: string; config?: any },
  locale: string,
): string {
  const translations = world.config?.translations as Record<string, WorldTranslationData> | undefined;
  const t = translations?.[locale];
  return t?.name || world.name;
}

export function getLocalizedWorldDescription(
  world: { description?: string | null; config?: any },
  locale: string,
): string {
  const translations = world.config?.translations as Record<string, WorldTranslationData> | undefined;
  const t = translations?.[locale];
  return t?.description || world.description || "";
}

export function getLocalizedWorldMeta(
  world: { name: string; description?: string | null; config?: any },
  locale: string,
): { name: string; description: string } {
  return {
    name: getLocalizedWorldName(world, locale),
    description: getLocalizedWorldDescription(world, locale),
  };
}
